import ActionCard from '../components/ActionCard';
import { Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useAPI } from '../services/api';

const HomePage = () => {
  const api = useAPI();
  const [cards, setCards] = useState([]);

  useEffect(() => {
    const getData = async () => {
      let { data } = await api.get('/task');
      setCards(data);
    };
    getData();
  }, [api]);

  return (
    <>
      <Row className="mb-4 mt-5" xxl={3} lg={3} md={2} sm={1} xs={1}>
        {cards.map(({ name, type, open_date, lock_date, is_open, redirect, description }, key) => (
          <ActionCard
            description={description}
            key={key}
            title={name}
            type={type}
            active={is_open}
            openDate={open_date ? open_date : null}
            lockDate={lock_date ? lock_date : null}
            redirect={redirect}
          />
        ))}
      </Row>
    </>
  );
};

export default HomePage;
